import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { Pagination } from '../../../../models/pagination';
import { AuditAction, EmployeeEditRecord } from '../../../../models/audit-action';
import { BaseComponent } from '../../../../components/base/base.component';
import { AuditService } from '../../../../services/audit.service';

@Component({
  selector: 'people-changes-report',
  templateUrl: './people-changes-report.component.html',
  styleUrls: ['./people-changes-report.component.css'],
  standalone: false
})
export class PeopleChangesReportComponent extends BaseComponent implements OnInit {
  @Input() startDate: Date;
  @Input() endDate: Date;
  @Input() clientCode: string;
  data: EmployeeEditRecord[];
  pagination: Pagination = new Pagination();
  sortKey: string;
  sortDirection: string;
  filters = {
    employeeNumberQuery: '',
    employeeNameQuery: '',
    activityQuery: '',
    attrNameQuery: '',
    userIdQuery: ''
  };

  // FIXME: find a better way to render payroll and other non-people management actions
  payrollKeys = [
    'CalendarId',
    'CalendarIds',
    'PayrollId',
    'PeriodEnd',
    'PayDate',
    'LocationId',
    'PayrollErrors',
    'PayrollWarnings'
  ];
  searchSubject = new Subject<void>();

  constructor(
    private auditService: AuditService,
    private route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit() {
    this.clientCode = this.route.snapshot.paramMap.get('client_code');

    this.getEmployeeAuditData();

    this.searchSubject.pipe(debounceTime(500)).subscribe(() => this.getEmployeeAuditData());
  }

  public filterBy(event) {
    this.pagination.Page = 1; // reset pagination after filters change
    this.searchSubject.next();
  }

  public getEmployeeAuditData() {
    this.auditService
      .getEmployeeAuditData(this.clientCode, {
        pageNum: this.pagination.Page,
        sortKey: this.sortKey,
        sortDirection: this.sortDirection,
        startDate: this.startDate,
        endDate: this.endDate,
        ...this.filters
      })
      .subscribe(resp => {
        this.data = resp.Items;
        this.pagination = resp.Pagination;
      });
  }

  public loadPage({ Page }: Pagination) {
    this.pagination.Page = Page;
    this.getEmployeeAuditData();
  }
}
